import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./../CustomedFields/FormikControl";

// function CustomerAdd(props, ref) {
const CustomerAdd = React.forwardRef((props, ref) => {
  // const dropdownOptions = [
  //   { key: "Select your course", value: "" },
  //   { key: "React", value: "react" },
  //   { key: "Angular", value: "angular" },
  //   { key: "Vue", value: "vue" },
  // ];

  // const checkboxOptions = [
  //   { key: "HTML", value: "html" },
  //   { key: "CSS", value: "css" },
  //   { key: "JavaScript", value: "javascript" },
  // ];

  const initialValues = {
    Name: "",
    CellNo: "",
    AlternetPhone: "",
    Email: "",
    Address: "",
  };

  const validationSchema = Yup.object({
    Name: Yup.string().required("Required"),
    CellNo: Yup.string().required("Required"),
    Email: Yup.string().email("Invalid email format"),

    // bio: Yup.string().required("Required"),
    // course: Yup.string().required("Required"),
    // courseDate: Yup.date().required("Required").nullable(),
  });

  const onSubmit = async (values) => {
    console.log("Form data", values);
    // alert("add customer submit");
    props.AddCustomerToDB(values);
  };

  // const onSubmit = (event) => {
  //   alert("Form submitted");
  //   event.preventDefault();
  //   //Your code here. For example,
  // };

  //********************* Form validation send to Parent form */
  React.useEffect(() => {
    // Update the document title using the browser API
    // alert("document.getElementById(submitButton).disabled");
    props.isValidChildFormInputs(
      document.getElementById("submitButton")?.disabled
    );
  }, [document.getElementById("submitButton")?.disabled]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        return (
          <Form>
            <FormikControl
              control="input"
              type="text"
              label="Name"
              name="Name"
            />
            <FormikControl
              control="input"
              type="text"
              label="Cell No"
              name="CellNo"
            />
            <FormikControl
              control="input"
              type="text"
              label="Alternet Phone"
              name="AlternetPhone"
            />
            <FormikControl
              control="input"
              type="text"
              label="Email"
              name="Email"
            />
            <FormikControl
              control="input"
              type="text"
              label="Address"
              name="Address"
            />
            {/* <FormikControl
              control="input"
              type="date"
              label="datetest"
              name="datetest"
            /> */}
            <button
              id="submitButton"
              type="submit"
              disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
              ref={ref}
            >
              Submit
            </button>
          </Form>
        );
      }}
    </Formik>
  );
});

export default CustomerAdd;
